import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParkingService } from '../../../../../../services/parking.service';

@Component({
    selector: 'app-parking-edit-confirm',
    templateUrl: './parking-edit-confirm.component.html',
    styleUrls: ['./parking-edit-confirm.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParkingEditConfirmComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();
  isLoading: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ParkingEditConfirmComponent>,
    private parkingService: ParkingService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    // if(this.data.admin == true) {
    //   alert('admin')
    // }
  }

  onConfirmClick() {
    const parkingSiteId = this.data.parkingSiteId;
    const orderParkingId = this.data.orderParkingId;
    this.isLoading = true;
    this.parkingService
      .setNewParkingSite(orderParkingId, parkingSiteId, this.data.admin)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        orderParking => {
          this.isLoading = false;
          console.log(orderParking);
          this.dialogRef.close(true);
        },
        error => {
          this.isLoading = false;
          this.snackBar.open(`Felkod: ${error.status}`, 'Doh!', {
            verticalPosition: 'top'
          });
        }
      );
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
